import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './styles/FrontPage.module.css'; 
import Login from '../../auth/Login';
import Register from '../../auth/Register';
import ForgotPassword from '../../auth/ForgotPassword';
import VerifyEmail from '../../auth/VerifyEmail';
import logo from '../../../images/logo_teal_background.png';

const FrontPage = () => {
    const [authModalState, setAuthModalState] = useState('sign up');
    const [acceptInvite, setAcceptInvite] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (location.state) {
            const { authModalState, acceptInvite } = location.state;
            if (authModalState) {
                setAuthModalState(authModalState);
            }
            if (acceptInvite) {
                setAcceptInvite(acceptInvite);
            }
        }
    }, [location.state]);

    const handleAuthChange = (newState) => {
        setAuthModalState(newState);
    };

    return (
        <div className={styles.pageContainer}>
            <div className={styles.splitScreenContainer}>
                <div className={styles.logoContainer}>
                    <div className={styles.logoAndSloganWrapper}>
                        <img src={logo} alt="AlphaScenario Logo" className={styles.logo} />
                        <div className={styles.sloganContainer}>
                            <p className={styles.sloganLine}>Interactive Content</p>
                            <p className={styles.sloganLine}>Tailored Experiences</p>
                        </div>
                    </div>
                </div>

                <div className={styles.authFormContainer}>
                    <div className={styles.mobileLogoContainer}>
                        <img src={logo} alt="AlphaScenario Logo" className={styles.mobileLogo} />
                    </div>

                    {(authModalState === 'login') && (
                        <Login 
                            setAuthModalState={handleAuthChange}
                            acceptInvite={acceptInvite}
                            showModal={true} 
                            setShowModal={() => {}} 
                            setAcceptInvite={setAcceptInvite}
                        />
                    )} 
                    {(authModalState === 'sign up') && (
                        <Register 
                            setAuthModalState={handleAuthChange}
                            acceptInvite={acceptInvite}
                            showModal={true}
                            setShowModal={() => {}}
                            setAcceptInvite={setAcceptInvite}
                        />
                    )} 
                    {(authModalState === 'forgot password') && (
                        <ForgotPassword 
                            setAuthModalState={handleAuthChange}
                        />
                    )} 
                    {(authModalState === 'verify email') && (
                        <VerifyEmail/>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FrontPage;